
import { Component, Prop, FormComponentBase} from "@/lib";
@Component({name:"hi-radio"})
export default class HiRadio extends FormComponentBase {
  @Prop({
    type: [Number, String],
    required: true,
    default: ""
  })
  value: string;
  @Prop({
    type: Array,
    default: () => {
      return [];
    }
  })
  radioList: Array<any>;

  @Prop({
    type: Boolean,
    default: false,
  })
  button: boolean;

  get groupType() {
    return this.button ? "button" : undefined;
  }
  get requiredRule() {
    return {
      required: true, //是否必填
      message: this.L("Validate.PleaseSelect", this.L(this.labelKey)), //验证信息
      trigger: "change" //触发方式    常用  blur 和 change}
    };
  }

  change(value){
    this.$emit('input', value);
    this.$emit('on-change', value);
  }
}
